import { __awaiter } from "tslib";
import { ImporterErrorCode } from '@tencent/mega-sdk-protocols';
export class PasswordLoadManager {
    constructor(getLoader) {
        this.state = 'init';
        this.onPasswordChange = (password) => {
            if (this.state === 'resolved') {
                return;
            }
            this.password = password;
            this.state = 'typed';
            this.load().catch(() => {
                this.state = 'loading';
            });
        };
        this.tryLoad = getLoader(this.onPasswordChange);
    }
    static load(getLoader) {
        return __awaiter(this, void 0, void 0, function* () {
            return new PasswordLoadManager(getLoader).load();
        });
    }
    static isPasswordError(code) {
        return code === ImporterErrorCode.kPasswordRequired || code === ImporterErrorCode.kInvalidPassword;
    }
    load() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.state === 'loading') {
                return;
            }
            this.state = 'loading';
            const code = yield this.tryLoad(this.password);
            if (PasswordLoadManager.isPasswordError(code)) {
                this.waitForPasswordChange();
            }
            else {
                this.resolve();
            }
        });
    }
    waitForPasswordChange() {
        this.state = 'typing';
    }
    resolve() {
        this.state = 'resolved';
    }
}
//# sourceMappingURL=password-load-manager.js.map